
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">開店申請列表</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->
                <p>查看開店申請</p>
                <div class="my-3"><b style="color:#BA0000;">開好店並裝機完成後，點擊開通完成以同步通知對應經銷商</b></div>
                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      placeholder="搜尋申請表單"
                      size="small"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                  <el-col :xs="48" :md="12">
                    <!--<router-link to="./portals/new" type="success">
                      <el-button type="primary" size="small"><i class="el-icon-circle-plus">新增入口</i></el-button>
                    </router-link>-->

                    <!--<router-link to="./portals/shops" type="success">
                      <el-button type="success" style="background-color: #9050cc;border-color: #9050cc;" size="small">查看店家目前上架到哪些Portal</el-button>
                    </router-link>-->
                  </el-col>
                </el-row>

                <data-tables :data="data" :filters="filters" :action-col="actionCol">
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                  <!--<el-table-column label="LOGO" prop="logo" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.logo"></template>
                  </el-table-column>
                  <el-table-column label="FAVICON"" prop="favicon" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.favicon"></template>
                  </el-table-column>
                  <el-table-column label="預設商店圖" prop="defaultShops" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.defaultShops"></template>
                  </el-table-column>-->
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      width="30%"
      :title="`確認是否要竣工：${this.registeredShop.registrationId}`"
      :visible.sync="showRegistrationConfirmMessage"
      append-to-body>
      <div style="text-align:center">
        <el-button round type="danger" icon="now-ui-icons" @click="registerShop">
          確認
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      showRegistrationConfirmMessage: false,
      registeredShop: {id: null, registrationId:""},
      titles: [
        // {
        //   prop: "id",
        //   label: "NO."
        // },
        {
          prop: "registrationId",
          label: "申請ID"
        },        
        {
          prop: "siName",
          label: "申請SI"
        },
        {
          prop: "customName",
          label: "申請人名稱"
        },
        {
          prop: "orderId",
          label: "SI訂單序號"
        },
        {
          prop: "types",
          label: "申請類型"
        },
        {
          prop: "statusStr",
          label: "狀態"
        },
        {
          prop: "createdTime",
          label: "申請時間"
        }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center",
          width: "300"
        },
        buttons: [
          // {
          //   props: {
          //     type: "success",
          //     size: "small",
          //     icon: "el-icon-s-marketing"
          //   },
          //   label: "下載申請資料",
          //   handler: row => {
          //     this.$router.push(`/registrations/${row.id}/download`);
          //   }
          // },
          {
            props: {
              type: "warning",
              size: "small",
              icon: "el-icon-setting"
            },
            label: "查看申請資料",
            handler: row => {
              this.$router.push(`/registrations/${row.id}`);
            }
          },
          {
            props: {
              type: "info",
              size: "small",
              icon: "el-icon-position",
            },
            label: "竣工",
            handler: (row) => {
              this.showRegistrationConfirmMessage = true;
              this.registeredShop = {id: row.id, registrationId: row.registrationId};
            },
          },
        ]
      },
      filters: [
        {
          value: "",
          prop: ["siName", "registrationId", "orderId"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getRegistrations() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/registrations`)
        .then(response => {
          
          this.data = response.data;
          for (let i = 0; i < this.data.length; ++i) {
            if (this.data[i].createdTs) {
              this.data[i].createdTime = moment.unix(this.data[i].createdTs).format('YYYY-MM-DD HH:mm:ss');
            }
            if (this.data[i].types) {
              let temp = this.data[i].types.split(',');
              let typeStr = '';
              for (let j = 0; j < temp.length; ++j) {
                if (j > 0)
                  typeStr += ',';

                switch(temp[j]) {
                  case 'contract':
                    typeStr += '合約';
                    break;
                  case 'service':
                    typeStr += '服務';
                    break;
                  case 'addons':
                    typeStr += '加購';
                    break;
                  default:
                    typeStr += temp[j];
                }
                this.data[i].types = typeStr;
              }
            }
            switch(this.data[i].status) {
              case 'D':
                this.data[i].statusStr = '完成';
                break;
              case 'N':
                this.data[i].statusStr = '新申請';
                break;
              case 'P':
                this.data[i].statusStr = '處理中';
                break;
            }
          }
         
          return response.data;
        });
    },
    registerShop() {
     axios.post(`${process.env.VUE_APP_APIHOST}/gaa/registrations/${this.registeredShop.id}/callback`)
      .then(response => {
          this.$message({
            type: 'success', message: `店面竣工成功：${this.registeredShop.registrationId}`
          });
          this.showRegistrationConfirmMessage = false;
        })
          .catch(error => {
            this.$message.error(`店面竣工失敗（${this.registeredShop.registrationId}）：${error.data.message}`);
            this.showRegistrationConfirmMessage = false;
        });
    }
  },
  mounted() {
    this.getRegistrations();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>